import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt, { useIsXLarge } from '../../../../shared/theme';
import { Container, Label, Value } from './styles';
import { formatValue } from '../shared-utils';
import PerformanceFeeCharged from '../fees-and-pricing-components/performance-fee-charged';

const Values = styled(Value)`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  & > small {
    margin: 0 2px 0 4px;
    font-weight: ${props => dt(props).theme.fontWeightBold};
    white-space: nowrap;
  }

  & > span {
    font-size: 12px;
    font-weight: ${props => dt(props).theme.fontWeightRegular};
    white-space: nowrap;
    line-height: 120%;

    ${props => dt(props).theme.isMobileOrTablet && `
      width: 100%;
    `};
  }

  & > [class^="performance-fee-charged"] {
    ${props => dt(props).theme.isMobileOrTablet && `
      height: 16px;
      padding: 0 5px;
      font-size: 11px;
      line-height: 7px;
      margin-left: 0;
      border-radius: 3px;
    `}

    ${props => !dt(props).theme.isXLarge && `
      margin-top: 4px;
    `}
  }

  ${props => dt(props).theme.isMobileOrTablet && `
    width: 104px;
  `};

  ${props => !dt(props).theme.isMobileOrTablet && !dt(props).theme.isXLarge && `
    max-width: 180px;
  `};
`;

export default function Fee({
  label,
  value,
  isPerformanceFeeChargedYes,
  isPerformanceFeeChargedNo,
  date,
}) {
  const valueToShow = formatValue(value, true);
  const isXLarge = useIsXLarge();

  return (
    <Container>
      <Label>{label}</Label>
      <Values>
        {valueToShow}
        {valueToShow !== 'N/A' && <small>p.a.</small>}
        {isPerformanceFeeChargedYes && <span className="performance-fee-label">+ Performance Fee</span>}
        {isPerformanceFeeChargedNo && !isXLarge
        && <PerformanceFeeCharged isPerformanceFeeCharged={false} />}
        {!!date && <span>{`(${date})`}</span>}
      </Values>
    </Container>
  );
}

Fee.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isPerformanceFeeChargedYes: PropTypes.bool,
  isPerformanceFeeChargedNo: PropTypes.bool,
  date: PropTypes.string,
};

Fee.defaultProps = {
  value: null,
  isPerformanceFeeChargedYes: false,
  isPerformanceFeeChargedNo: false,
  date: null,
};
